import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useCustomerAuth, formatApiError } from "@/context/CustomerAuthContext";

/**
 * AuthCallback — Emergent Google Auth redirects here with `#session_id=...`.
 * We exchange the session_id server-side, set the cookie, and redirect to /account.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export const AuthCallback = () => {
  const location = useLocation();
  const nav = useNavigate();
  const { completeGoogleSession } = useCustomerAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/account/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        await completeGoogleSession(sessionId);
        toast.success("Signed in with Google");
        // strip the hash so refresh doesn't re-run the exchange
        window.history.replaceState({}, "", "/account");
        nav("/account", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err?.response?.data?.detail, "Google sign-in failed"));
        nav("/account/login", { replace: true });
      }
    })();
  }, [location, completeGoogleSession, nav]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-bone">
      <div className="text-forest">
        <div className="overline text-gold mb-3">§ Signing you in</div>
        <div className="font-display text-forest text-3xl">One moment…</div>
      </div>
    </main>
  );
};
